import React, { useEffect, useState, useContext } from 'react'
import {
    BrowserRouter as Router,
    Link,
    Navigate,
    useNavigate,
    useParams
} from "react-router-dom"
import { GlobalContext } from '../../GlobalContext'
import Button from '../../formfields/Button'
import Card from '../../ui-elements/Card'
import RedAlert from '../../ui-elements/RedAlert'
import Spinner from '../../ui-elements/Spinner'
import ChecklistSetupWrapper from '../wrapper/ChecklistSetupWrapper'
import SingleCheckWindow from './SingleCheckWindow'
import YellowAlert from '../../ui-elements/YellowAlert'


type Props = {
    settingsFormFields: ObjectStringKeyAnyValue
    thisChecklist: ObjectStringKeyAnyValue | null
    settingsFormErrors: ObjectStringKeyAnyValue
    setSettingsFormFields: React.Dispatch<React.SetStateAction<any>>
}

function ApplyChecklistCategories({
    settingsFormFields,
    thisChecklist,
    settingsFormErrors,
    setSettingsFormFields
}: Props) {

    const {
        tableData,
        currentOrganisation,
        sendMessageToWebsocket,
    } = useContext(GlobalContext)


    const handleCheckboxChange = (valueId: string, checked: boolean) => {
        const newFieldValues: ObjectStringKeyAnyValue = { ...settingsFormFields }
        if (!newFieldValues.ChecklistCategories) {
            newFieldValues.ChecklistCategories = []
        } else {
            newFieldValues.ChecklistCategories = [...newFieldValues.ChecklistCategories]
        }

        if (checked === true) {
            newFieldValues.ChecklistCategories.push(valueId)
        } else {
            const index = newFieldValues.ChecklistCategories.indexOf(valueId)
            if (index > -1) {
                newFieldValues.ChecklistCategories.splice(index, 1)
            }
        }
        setSettingsFormFields(newFieldValues)
    }


    if (!tableData || !tableData.ChecklistCategories) {
        return null
    }


    return <div className={`flex flex-col gap-2`}>
        <h3 className={`font-righteous text-brandblue text-lg`}>Checklist categories:</h3>

        {Object.keys(tableData.ChecklistCategories).length === 0 && <YellowAlert><p>No categories have been set up yet. <Link to={`/manage-checklist-categories`} className={`hover:opacity-80 cursor-pointer underline`}>Manage your checklist categories here</Link>.</p></YellowAlert>}


        {Object.keys(tableData.ChecklistCategories).length > 0 && <div className={`flex flex-col flex-wrap gap-2`}>{
            Object.keys(tableData.ChecklistCategories).map((categoryId: any) => {
                const thisCategory = tableData.ChecklistCategories[categoryId]
                const thisCategoryValueIds = thisCategory.Values ? Object.keys(thisCategory.Values) : []

                return <div key={categoryId} className={`rounded px-2 py-2 bg-white border-gray-300 border flex flex-col gap-2`}>
                    <h4 className={`font-bold`}>{thisCategory.DisplayName}</h4>
                    {thisCategoryValueIds.length === 0 && <p className={`text-xs`}>No values for this category</p>}
                    {thisCategoryValueIds.length > 0 && <div className={`flex flex-row flex-wrap gap-4`}>

                        {thisCategoryValueIds.map((valueId: any) => {
                            const thisValue = thisCategory.Values[valueId]
                            const isThisChecked = settingsFormFields.ChecklistCategories && settingsFormFields.ChecklistCategories.includes(valueId) ? true : false
                            return <div key={valueId} className={`flex flex-row gap-1 items-center`}>
                                <input
                                    type='checkbox'
                                    className={`w-4 h-4`}
                                    name={`ChecklistCategories[${categoryId}][${valueId}]`}
                                    id={`ChecklistCategories[${categoryId}][${valueId}]`}
                                    value={thisValue.DisplayName}
                                    checked={isThisChecked ? true : false}
                                    onChange={(e) => { handleCheckboxChange(valueId, e.target.checked) }}
                                />
                                <label htmlFor={`ChecklistCategories[${categoryId}][${valueId}]`} className={`text-sm`}>{thisValue.DisplayName}</label>
                            </div>
                        })}

                    </div>}

                </div>
            })}
        </div>}


        {settingsFormErrors['ChecklistCategories'] && <RedAlert>{settingsFormErrors['ChecklistCategories']}</RedAlert>}
    </div>

}



export default ApplyChecklistCategories